import ListItemWithMovieContainer from '../DragAndDropItems/cont/ListItemWithMovieContainer'
import ListItemMovieContainer from '../DragAndDropItems/cont/ListItemMovieContainer'
import { AD, ADVERTISEMENT, HIGHLIGHT, MOVIE, WEISCHER } from '../../constants/itemTypes'
import ListItemAdvertisementContainer from '../DragAndDropItems/cont/ListItemAdvertisementContainer'
import ListItemWeischerContainer from '../DragAndDropItems/cont/ListItemWeischerContainer'
import ListItemNoDataContainer from '../DragAndDropItems/cont/ListItemNoDataContainer'

const ProgramDragDropItemSwitch = ({
    itemId,
    itemType, 
    itemData, 
    additionalClass=false,
    basicUrl,
    params,
    isSelected = false,
    canEdit = false, 
    canDelete = false, 
    deleteItem = false,
}) => {
    const pathnameEdit = canEdit ? `${basicUrl}/${itemType}/${itemId}` : false
    const onDeleteItem = canDelete ? () => deleteItem(itemId, itemType) : false

    //ToDo: Features

    return (
        !itemData ? (
            <ListItemNoDataContainer/>
        ) : MOVIE === itemType ? (
            <ListItemMovieContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : (AD === itemType || HIGHLIGHT === itemType)  ? (
            <ListItemWithMovieContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : ADVERTISEMENT ===itemType ? (
            <ListItemAdvertisementContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : WEISCHER === itemType ? (
            <ListItemWeischerContainer
                itemType={itemType}
                itemData={itemData}
                additionalClass={additionalClass}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={onDeleteItem}
            />
        ) : ''
    )
}

export default ProgramDragDropItemSwitch